const MARKET_NAME = 'Mercado';
const APP_NAME = 'Agro Lab PR';

const esPR = {
  APP_VERSION: '1.0.0',
  APP_NAME,
  APP_NAME_WITH_COLOR: 'Agro <0>Lab</0> PR',
  MARKET_NAME,
  NAV: {
    HOME: 'Inicio',
    BTN_LOGIN: 'Iniciar Sesión',
    GO_TO_MARKET: 'Ir al mercado',
    WHO_ARE_WE: '¿Quiénes somos?',
    MEGA_MENU:{
      TITLE: 'Más',
      CHILDREN_1:{
        SUBHEADER: 'Páginas',
        PAGE_1: APP_NAME,
        PAGE_2: 'Beneficios',
        PAGE_3: 'Funcionalidades',
        PAGE_4: '¿Cómo funciona?',
        PAGE_5: 'Preguntas frecuentes',
        PAGE_6: 'Dashboard',
        PAGE_7: `¿Qué es el sello ${APP_NAME}?`,
        PAGE_8: 'Contáctanos'
      },
      CHILDREN_2:{
        SUBHEADER: 'Autenticación',
        PAGE_1: 'Iniciar sesión',
        PAGE_2: 'Regístrate',
        PAGE_3: 'Olvide mi contraseña',
        PAGE_4: 'Validar código de autenticacuón',
      },
    }
  },
  HOME: {
    META_TITLE: 'Inicio',
    HERO: {
      WELCOME: 'Bienvenidos al',
      SUBTITLE: 'Conecta con agricultores locales y asegura productos frescos y trazables para tu supermercado, restaurante o la cocina de tu casa.',
      BTN_REGISTER: 'Regístrate',
      BTN_VISIT_THE_APP: 'Visítanos en',
    },
    HOME_MINIMAL: {
      TITLE: `¿Qué es el mercado?`,
      SUBTITLE: `${MARKET_NAME}`,
      DESCRIPTION: 'El {{MARKET_NAME}} de {{APP_NAME}} es la manera más fácil en la que los supermercados y restaurantes pueden buscar productos frescos y de calidad. Conectamos a los comercios directamente con agricultores locales, permitiéndoles realizar pedidos directo a los agricultores y garantizar la frescura de cada producto. Además, tendrás acceso al plan de siembra para conocer la disponibilidad futura de los productos y podrás ver la trazabilidad de los cultivos, lo que te garantiza total transparencia sobre lo que compras. Y si solo eres un amante de la cocina, también puedes encontrar productos frescos para disfrutar en tu casa.',
    },
    BENEFIT: {
      TITLE: '¿Cuáles son los beneficios?',
      SUBTITLE: 'Beneficios',
      DESCRIPTION: '¡Explora todas las ventajas que nuestra plataforma tiene para ofrecer y empieza a transformar la forma en que gestionas tus pedidos hoy mismo!',
      BTN_VIEW_ALL: 'Ver todos los beneficios',
    },
    FUNCIONALITIES: {
      TITLE: 'Algunas de las funcionalidades',
      SUBTITLE: 'Funcionalidades',
      DESCRIPTION: 'Te ofrecemos las mejores herramientas para que puedas planificar la adquisición de los productos que necesitas. Estas son solo algunas. Regístrate y disfruta de muchas más.',
      BTN_GO_TO_ALL: 'Ver todas las funcionalidades',      
    },
    HOW_DOES_IT_WORK: {
      TITLE: '¿Cómo funciona?',
      SUBTITLE: 'Fácil funcionamiento',
      DESCRIPTION: `Es sumamente fácil comenzar a utilizar el ${MARKET_NAME}. Para hacerlo solo debes registrarte.`,
      BTN_REGISTER: 'Regístrate',
      STEPS: 'Paso',
      STEPS_LIST: {
        ONE: {
          TITLE: 'Crear una cuenta',
          DESCRIPTION: 'Completa el formulario e inicia sesión.',
        },
        TWO: {
          TITLE: 'Explora los productos',
          DESCRIPTION: 'Mira qué agricultores están ofreciendo productos y qué está próximo a cosecharse.',
        },
        THREE: {
          TITLE: 'Realiza tus pedidos',
          DESCRIPTION: 'Selecciona los productos frescos que necesitas y realiza la compra directamente a los agricultores.',
        },
        FOUR: {
          TITLE: 'Accede a la trazabilidad',
          DESCRIPTION: 'Obtén la información de lo que ha pasado en el tiempo de vida del producto.',
        },
      },
    },
    HOME_FREQUENTLY_ASKED: {
      TITLE: 'Preguntas Frecuentes',
      SUBTITLE: 'Dudas',
      DESCRIPTION: '',
      BTN_MORE: '¿Tienes alguna otra duda?',
      ASK_LIST: {
        ONE: {
          TITLE: `¿Qué tipos de productos puedo encontrar en el ${MARKET_NAME}?`,
          DESCRIPTION: `Puedes encontrar diferentes tipos de productos y variedades que hayan sido registrados en el sistema por los agricultores suscritos en ${APP_NAME}.`,
        },
        TWO: {
          TITLE: '¿Cómo puedo confiar en la trazabilidad de los productos?',
          DESCRIPTION: `La trazabilidad de los productos es gestionada desde ${APP_NAME}. Este sistema realiza la trazabilidad según los datos que los agricultores hayan ingresado de cada cultivo.`,
        },
        THREE: {
          TITLE: '¿Es posible programar órdenes futuras?',
          DESCRIPTION: `Sí, es posible programar órdenes. Desde el Panel de control podrás ver los productos que estarán disponibles en el futuro de acuerdo con los planes de siembra registrados en ${APP_NAME}.`,
        },
        FOUR: {
          TITLE: '¿Cómo puedo contactar a los agricultores?',
          DESCRIPTION: `Podrás contactar a los agricultores una vez te registres en el ${MARKET_NAME}.`,
        },
        FIVE: {
          TITLE: '¿Qué es el Panel de control?',
          DESCRIPTION: `El Panel de control es la parte administrativa del ${MARKET_NAME}. Desde ahí podrás gestionar los pedidos, entregas, métodos de entrega, ver planes de siembra y cosecha, obtener los datos de trazabilidad de cada producto, entre muchas otras funcionalidades.`,
        },
        SIX: {
          TITLE: '¿Qué es el Sello Agro Lab?',
          DESCRIPTION: `El Sello Agro Lab es una certificación que se le asigna a los cultivos o productos si cumplen con los estándares o requerimientos impuestos por ${APP_NAME}.`,
        },
      },
    },
    HOME_WIDGET:{
      TITLE: 'Comprueba por ti mismo la viabilidad',
      SUBTITLE: 'Dashboard',
      DESCRIPTION: '',
      BTN_REGISTER: 'Regístrate y comienza a explorar',
      WIDGET_LIST: {
        WIDGET_1: {
          TITLE: 'Agricultores',
          SUBTITLE: 'Registrados',
          ICON: 'fluent-emoji-high-contrast:farmer'
        },
        WIDGET_2: {
          TITLE: 'Productos/Cultivos',
          SUBTITLE: 'Disponibles',
          ICON: 'ph:plant-duotone'
        },
        WIDGET_3: {
          TITLE: 'Planes de siembra',
          SUBTITLE: 'Creados',
          ICON: 'ant-design:schedule-twotone'
        },
        WIDGET_4: {
          TITLE: 'Super mercados',
          SUBTITLE: 'Registrados',
          ICON: 'ic:twotone-maps-home-work'
        },
        WIDGET_5: {
          TITLE: 'Restaurantes',
          SUBTITLE: 'Registrados',
          ICON: 'icon-park-twotone:home-two'
        },
        WIDGET_6: {
          TITLE: 'Entregas',
          SUBTITLE: 'Realizadas',
          ICON: 'iconamoon:delivery-duotone'
        },
        WIDGET_7: {
          TITLE: 'Compras',
          SUBTITLE: 'Realizadas',
          ICON: 'iconamoon:invoice-duotone'
        },
      }
    },
    HOME_STAMP_AGROLAB:{
      TITLE: `¿Qué es el Sello de <br />${APP_NAME}?`,
      SUBTITLE: 'Sello',
      DESCRIPTION: `El sello representa el compromiso de los productores o agricultores con la excelencia y la sostenibilidad. Los productos que portan este sello cumplen con los estándares de calidad, seguridad y sostenibilidad ambiental de ${APP_NAME}, asegurando que cada bocado no solo sea delicioso, sino también saludable y responsable con el entorno. Al elegir productos con el Sello, los consumidores apoyan prácticas agrícolas responsables y fomentan un futuro más sostenible para la agricultura.`,
      BTN_READ_MORE: 'Quiero saber más',      
    },
    HOME_CONTACT: {
      TITLE: '¿Cómo nos consigues?',
      SUBTITLE: 'Contáctanos',
      DESCRIPTION: '',
    },
    ABOUT_US: {
      TITLE: `¿Qué opinan del ${MARKET_NAME}?`,
      SUBTITLE: 'Testimonios',
      DESCRIPTION: 'Queremos que todos puedan beneficiarse de la compra de productos frescos y locales. Únete y sé parte de aquellos que lo están logrando.',
      BTN_READ_MORE: 'Únete ahora mismo',
    },
  },
  ABOUT_US: {
    META_TITLE: '¿Quiénes somos?',
    HERO:{      
      TITLE_1: '¿Quiénes',
      TITLE_2: 'Somos?',
      SUBTITLE: 'Somos aquellos que estan trazando un camino hacia un futuro en el que los agricultores y consumidores se conecten para obtener lo mejor que ambos pueden ofrecer.',
    },
    WATH_DO_WE_DO:{
      TITLE: '¿Qué hacemos?',
      SUBTITLE: 'Nuestro impacto',
      TITLE_2: '¿Cómo estamos impactando?',
      DESCRIPTION: 'En el Mercado de Agro Lab PR, conectamos a supermercados, restaurantes y consumidores directamente con los agricultores locales para garantizar productos frescos y de alta calidad. Facilitamos el proceso de compra permitiendo a los comercios realizar pedidos directamente a los productores, asegurando la frescura en cada entrega. Además, ofrecemos acceso al plan de siembra para que nuestros usuarios conozcan la disponibilidad futura de los productos y puedan planificar sus compras con antelación. Con nuestra plataforma, proporcionamos total transparencia mediante la trazabilidad de los cultivos, brindando confianza sobre el origen y el proceso de cada alimento. Ya sea para abastecer un negocio o para disfrutar de ingredientes frescos en casa, somos la opción más sencilla y confiable para obtener productos locales directamente del campo.',
      LIST:{
        ITEM_1:{
          TITLE: 'Aumento en el consumo local',
          DESCRIPTION: 'Facilitamos el acceso a productos locales aumentando el uso de los mismos en supermercados, restaurantes y hogares.'
        },
        ITEM_2:{
          TITLE: 'Costos de intermediarios',
          DESCRIPTION: 'Eliminando los intermediarios hacemos que tengan un ahorro en sus costos asociados con la compra de productos frescos.'
        },
        ITEM_3:{
          TITLE: 'Frescura en los productos',
          DESCRIPTION: 'Al no tener intermediarios, se reduce el tiempo de entrega y se obtiene un producto más fresco directamente de la mano del agricultor. Esto permite que en los supermercados y restaurantes los productos puedan tener un tiempo de vida mayor. Todo esto pudiera reflejarse en una menor cantidad de alimentos desperdiciados.'
        },
        ITEM_4:{
          TITLE: 'Transparencia',
          DESCRIPTION: 'La trazabilidad puede mejorar la confianza del consumidor y aumentar la preferencia por productos locales, generando una mayor lealtad por parte de los clientes.'
        },
        ITEM_5:{
          TITLE: 'Incremento de ingresos',
          DESCRIPTION: 'Al tener acceso directo a los compradores, los agricultores podrían ver un aumento en las ventas y optimizar su producción de acuerdo a la demanda real.'
        },
      }
    },
    ABOUT_VISION: {
      TITLE: 'Nuestra visión y misión',
      MISION: 'Misión',
      VISION: 'Visión',
      SUBTITLE: '',
      DESCRIPTION: '',
      VISION_DESCRIPTION: 'Ser la plataforma líder en Puerto Rico que conecta de manera directa a agricultores locales con supermercados, restaurantes y consumidores finales, impulsando una cadena de suministro de alimentos más transparente, eficiente y sostenible, donde la frescura y la calidad de los productos sean la norma.',
      MISION_DESCRIPTION: 'Facilitar el acceso a productos frescos y de alta calidad cultivados localmente, creando un ecosistema que beneficie tanto a los agricultores como a los compradores. A través de nuestra plataforma, buscamos que los agricultores adopten esta tecnología que les permita vender sus productos de manera directa y transparente, mientras ofrecemos a los supermercados, restaurantes y consumidores finales una solución confiable para adquirir alimentos frescos, trazables y sostenibles.'
    },
    ABOUT_TEAM:{
      TITLE: 'Nuestro equipo',
      SUBTITLE: 'Equipo',
      DESCRIPTION: 'Para poder lograr con nuestras metas y objetivos contamos con la experiencia de',
    },
  },
  BENEFIT_PAGE:{
    META_TITLE: 'Beneficios',
    BTN_REGISTER: 'Regístrate',
    HERO:{
      TITLE_1:'¿Cuales',
      TITLE_2:'son',
      TITLE_3:'los',
      TITLE_4:'beneficios?',
      SUBTITLE:`Regístrate y explora todos los beneficios que te ofrece el ${MARKET_NAME}`
    },
    ALL_BENEFIT:{
      TITLE: `¿Qué te ofrecemos?`,
      SUBTITLE: 'Beneficios',
      DESCRIPTION: 'Estos son solo algunos de los beneficios que obtienes al registrarte.'
    },
    BENEFIT_LIST:{
      BENEFIT_1: {
        TITLE: 'Acceso a productos locales',
        DESCRIPTION: 'Permite a los supermercados y restaurantes hacer pedidos directamente a los agricultores.'
      },
      BENEFIT_2: {
        TITLE: 'Trazabilidad completa',
        DESCRIPTION: ' En ella tendrás la información detallada sobre el proceso de cultivo: fertilizantes, pesticidas, trabajos en campo y mucho más. En resumen, tendrás la información del producto que quieres adquirir desde el momento en que se compró la semilla o plántula hasta el día en que se cosechó.'
      },
      BENEFIT_3: {
        TITLE: 'Facil planificación de inventario',
        DESCRIPTION: 'Los supermercados, restaurantes o apasionados por la cocina pueden ver el plan de siembra y preparar sus compras de acuerdo con las fechas de cosecha.'
      },
      BENEFIT_4: {
        TITLE: 'Fomenta el apoyo a la comunidad local',
        DESCRIPTION: 'Apoyar la agricultura local y promover la sostenibilidad.'
      },
      BENEFIT_5: {
        TITLE: 'Precios competitivos',
        DESCRIPTION: 'Al no tener un intermediario se pueden obtener precios perfectamente equilibrados.'
      },
      BENEFIT_6: {
        TITLE: 'Envíos rápidos',
        DESCRIPTION: 'Los productos son entregados según lo acordado con el agricultor. De esta manera se puede garantizar frescura y rapidez en cada pedido.'
      },
      BENEFIT_7: {
        TITLE: 'Soporte local',
        DESCRIPTION: 'Brindamos soporte directo mediante llamadas, emails y reuniones virtuales o presenciales.'
      },
    }
  },
  FUNCIONALITY_PAGE:{
    META_TITLE: 'Funcionalidades',
    BTN_REGISTER: 'Regístrate',
    HERO:{
      TITLE_1:'¿Cuales',
      TITLE_2:'son',
      TITLE_3:'las',
      TITLE_4:'funcionalidades?',
      SUBTITLE:'Siempre estamos innovando e implementando las mejores funcionalidades para facilitarte el proceso de obtener productos frescos'
    },
    ALL_FUNCIONALITY:{
      TITLE: `Estas son algunas de las funcionalidades`,
      SUBTITLE: 'Funcionalidades',
      DESCRIPTION: ''
    },
    FUNCIONALITY_LIST:{
      ITEM_1: {
        ICON: 'icon-park-twotone:seedling',
        TITLE: 'Planes de siembra',
        DESCRIPTION: 'Obtendrás acceso a los planes de siembra de los agricultores para que puedas realizar tus órdenes de compra de manera planificada.',
      },
      ITEM_2: {
        ICON: 'ph:calendar-check-duotone',
        TITLE: 'Calendario de cultivos',
        DESCRIPTION: 'Visualiza qué productos hay disponibles de manera fácil y sencilla.',
      },
      ITEM_3: {
        ICON: 'ic:twotone-route',
        TITLE: 'Trazabilidad completa',
        DESCRIPTION: 'La transparencia es muy importante y más cuando se trata de alimentos. Es por eso que, desde el panel de control, podrás ver todo lo relacionado con el producto que compras.',
      },
      ITEM_4: {
        ICON: 'iconamoon:delivery-duotone',
        TITLE: 'Planificación de entregas',
        DESCRIPTION: 'Coordina con los agricultores la forma en que deseas recibir el producto.',
      },
      ITEM_5: {
        ICON: 'duo-icons:dashboard',
        TITLE: 'Panel de control',
        DESCRIPTION: 'Hemos creado un panel para que puedas ver toda la información relacionada.',
      },
      ITEM_6: {
        ICON: 'ant-design:mobile-twotone',
        TITLE: 'Acceso multiplataforma',
        DESCRIPTION: 'Accede a nuestra app desde cualquier dispositivo con acceso a internet.',
      },
    }
  },
  AGROLAB_STAMP_PAGE:{
    META_TITLE: 'Sello Agro Lab PR',
    HERO:{
      TITLE_1: '¿Qué',
      TITLE_2: 'es',
      TITLE_3: 'el',
      TITLE_4: 'Sello',
      TITLE_5: 'de',
      TITLE_6:  'Agro',
      TITLE_7:  'Lab',
      TITLE_8:  'PR?',
      SUBTITLE: 'Este es el Sello de calidad'
    },
    AGROLAB_STAMP:{
      TITLE: `¿Qué es el Sello de ${APP_NAME}?`,      
      SUBTITLE: 'Sello',
      TITLE_2: 'Estandares de calidad',
      SUBTITLE_2: 'Estandares AGRO 1001',
      SPAN: 'Estandar',
      DESCRIPTION: 'El sello representa el compromiso de los productores o agricultores con la excelencia y la sostenibilidad. Los productos que portan este sello cumplen con los estándares de calidad, seguridad y sostenibilidad ambiental de Agro Lab PR, asegurando que cada bocado no solo sea delicioso, sino también saludable y responsable con el entorno. Al elegir productos con el Sello, los consumidores apoyan prácticas agrícolas responsables y fomentan un futuro más sostenible para la agricultura.',
      BTN_REGISTER: 'Regístrate'
    },
    DISCLAIMER: `${APP_NAME} solo valida exista información o datos relacionados en cada uno de los estandares. No aseguramos con esto que la misma sea veridica ya que esto queda en la entera responsabilidad del productor o agricultor.`,
    QUALITY_LIST: {       
      ITEM_1: {
        TITLE: 'Certificaciones de cumplimiento',
        DESCRIPTION: 'El agricultor ha sido certificado por FSMA, Global GAP, Fair Trade, certificaciones específicas del país o de alguna agencia reguladora, y ha proporcionado dicha evidencia.',
        ICON: ''
      },
      ITEM_2: {
        TITLE: 'Trazabilidad',
        DESCRIPTION: 'El producto cumple con los requisitos mínimos de trazabilidad. Se puede identificar el número de rastreo de la semilla o plántula, así como el número de lote y la información del predio donde se cultivó. Se proporciona la fecha de cosecha y los destinatarios a quienes se ha vendido el producto.',
        ICON: ''
      },
      ITEM_3: {
        TITLE: 'Capacitación de personal',
        DESCRIPTION: 'El personal que trabaja en la finca debe recibir capacitación periódica en manejo de cultivos, seguridad alimentaria e higiene, y evidenciarla mediante el formulario correspondiente provisto por Agro Lab PR.',
        ICON: ''
      },
      ITEM_4: {
        TITLE: 'Formulario de inspección trimestral',
        DESCRIPTION: 'Los productores que reciban el sello de calidad de Agro Lab PR deben estar sujetos a auditorías periódicas para verificar el cumplimiento continuo de los estándares de calidad. Estas auditorías se llevan a cabo trimestralmente y deben tener una puntuación de no menos de 90%.',
        ICON: ''
      },
      ITEM_5: {
        TITLE: 'Inspección de producto agrícola',
        DESCRIPTION: 'Todos los productos deben ser sometidos a una inspección por parte del agricultor. Este evaluará el producto utilizando el Formulario de Inspección de Producto Agrícola proporcionado por Agro Lab PR, el cual detalla aspectos fundamentales como frescura, integridad, prácticas agrícolas sostenibles, trazabilidad y cumplimiento regulatorio. El formulario debe ser completado y firmado por el productor, confirmando que el producto cumple con los estándares establecidos.',
        ICON: ''
      },
    },
    QUALITY_LIST_PLUS: {
      TITLE: 'Estandar superior',
      SUBTITLE: 'Estandares AGRO 1002',
      ITEM_1: {
        TITLE: 'Auditorías presenciales',
        DESCRIPTION: 'Para obtener esta certificación, el productor debe solicitar la inspección presencial de un auditor de Agro Lab PR. La certificación AGRO 1001 es realizada por el propio productor, mientras que la AGRO 1002 es llevada a cabo por auditores externos, lo que añade un nivel adicional de objetividad y elimina cualquier posible conflicto de interés.',
        ICON: ''
      },      
    }
  },
  CONTACT_PAGE:{
    META_TITLE: 'Contáctanos',
    HERO: {
      TITLE_1: '¿Cómo',
      TITLE_2: 'nos',
      TITLE_3: 'encuentras?',
      SUBTITLE: '',
      DESCRIPTION: '',
    },
    CONTACT_FORM:{
      TITLE: 'No dudes en contactarnos.',
      SUBJECT: 'Asunto',
      NAME: 'Nombre',
      EMAIL: 'Correo electrónico',
      PHONE: 'Teléfono',
      MESSAGE: 'Escribe aquí tu mensaje',
      BTN_SEND_EMAIL: 'Enviar mensaje',
      REQUIRED: {
        SUBJECT: 'El asunto es requerido',
        NAME: 'El nombre es requerido',
        EMAIL: 'El correo electrónico es requerido',
        INVALID_EMAIL: 'El correo electrónico no es valido',
        PHONE: 'El teléfono es requerido',
        INVALID_PHONE: 'El teléfono no es valido',
        ONLY_NUMBER: 'Solo se aceptan números',
        ERROR: 'Ha ocurrido un error',
        MESSAGE: 'El mensaje es requerido'
      },
      MODAL: {
        TITLE: 'Mensaje enviado',
        BODY: 'Hemos recibido su mensaje. En breve uno de nuestros representantes se estará comunicando. Gracias.',
        BTN_CONFIRM: 'Ok, gracias'
      }
    },
  },
  CONTACT: {
    EMAIL: 'info@agrolabpr.com',
    PHONE_1: '(787) 371-9276',
    PHONE_2: '(787) 602-8461',
    DIRECTION: 'Mi presencia es online, estoy en todos los lugares y me puedes conseguir siempre y cuando tengas internet :)',
  },
  FOOTER:{
    RIGHT_RESERVED: 'Todos los derechos reservados.',
    CREATED_BY: APP_NAME,
    DESCRIPTION: '',
    LINKS:{
      ITEM_1:{
        TITLE: 'Otros',
        LINK_1: 'Sobre nosotros',
        LINK_2: 'Contáctanos',
        LINK_3: 'Sello Agro Lab PR',
      },
      ITEM_2:{
        TITLE: 'Legal',
        LINK_1: 'Terminos',
        LINK_2: 'Condiciones',
      },
      ITEM_3:{
        TITLE: 'Contáctanos',
        LINK_1: 'info@agrolabpr.com',
        LINK_2: '(787) 371-9276 / (787) 602-8461',
      },
    },
  },
  REGISTER:{
    META_TITLE:'Registrate',
    GET_STARTED: 'Registrate totalmente gratis',
    ALREADY_ACCOUNT: '¿Ya tienes una cuenta?',
    FORM: {
      FIRST_NAME: 'Nombre',
      LAST_NAME: 'Apellidos',
      PASSWORD: 'Contraseña',
      USERNAME: 'Nombre de usuario',
      EMAIL: 'Correo electrónico',
      CREATE_ACCOUNT: 'Crear mi cuenta',
      REQUIRED: {
        FIRST_NAME: 'El nombre es requerido',
        LAST_NAME: 'El apellido es requerido',
        PASSWORD: 'La contrasña es requerida',
        USERNAME: 'El nombre de usuario es requerido',
      }
    }
  },
  PAGE_404:{
    TITLE: 'Lo sentimos, no hemos encontrado la página',
    DESCRIPTION: 'Lo sentimos, no pudimos encontrar la página que estás buscando. ¿Quizás escribiste mal la URL? Asegúrate de revisarlo.',
    CODE: '404',
    BTN_ACTION: 'Regresar al inicio'
  },
  PAGE_500:{
    TITLE: 'Ha ocurrido un error interno',
    DESCRIPTION: 'Lo sentimos, ha ocurrido un error. Por favor, intentalo de nuevo.',
    CODE: '404',
    BTN_ACTION: 'Regresar al inicio'
  },
  MAINTENANCE_PAGE: {
    META_TITLE: 'Próximamente',
    TITLE: '¡Próximamente!',
    DESCRIPTION: 'Estamos trabajando muy duro para que la tengas disponible lo más pronto posible.',
    BTN_GO_TO_HOME: 'Ir al inicio'
  },
  COMING_SOON_PAGE: {
    META_TITLE: 'Mantenimiento',
    TITLE: 'Esta sección se encuentra en mantenimiento',
    DESCRIPTION: 'Estamos trabajando muy duro para que la tengas disponible lo más pronto posible.',
    BTN_GO_TO_HOME: 'Ir al inicio',
    DAYS: 'Días',
    HOURS: 'Horas',
    MINUTES: 'Minutos',
    SECONDS: 'Segundos',
    SOCIAL_MEDIA_DESCRIPTION: 'Siguenos en nuestras redes sociales y mantente informado.'
  },
  COMPACT_HEADER: {
    NEED_HELP: '¿Necesitas ayuda?'
  },
  ECOMMERCE: {
    META_TITLE: MARKET_NAME,
    PRODUCT_NOT_FOUND: 'No hay productos.',
    PRODUCT_FOUND: 'Productos encontrados',
    NO_SHOPS_FOUND: 'No hay tiendas disponibles.',
    BREAD_CRUMBS_HEADER: {
      TITLE: MARKET_NAME,
      TITLE_2: 'Negocios'
    },
    PRODUCT_VIEW: {
      META_TITLE: 'Producto',
      BREAD_CRUMBS_HEADER: {
        TITLE_1: MARKET_NAME,
        TITLE_2: 'Productos',
      },
      TABS: {
        ITEM_1: 'Descripción',
        PACKAGING_LIST: {
          TITLE: 'Información del producto',
          PACKAGE: 'Empaque',
          QUANTITY: 'Cantidad',
          PRICE: 'Precio'
        },
        ITEM_2: 'Negocio',
        BUSINESS_INFORMATION: {
          TITLE: 'Información del negocio'
        },
      },
      PACKAGE: 'Empaque',
      QUANTITY: 'Cantidad',
      AVAILABLE: 'Disponible'
    },
    SHOP_FILTER_DRAWER: {
      TITLE: 'Filtros',
      BUSINESS: 'Negocios',
      CITIES: 'Pueblos',
      TAGS: 'Etiquetas',
      PRICE_RANGE: 'Rango de precios',
      MIN: 'Min',
      MAX: 'Max',
      CLEAR_BUTTON: 'Limpiar filtros'
    },
    SORT_BY: {
      TITLE: 'Ordenar por:',
      FEATURED: 'Destacados',
      NEWEST: 'Más recientes',
      PRICE_DESC: 'Precio: Mayor - Menor',
      PRICE_ASC: 'Precio: Menor - Mayor'
    },
    TAG_FILTERED: {
      BUSINESS: 'Negocios:',
      CITIES: 'Pueblos:',
      TAGS: 'Etiquetas:',
      PRICES: 'Rango de precios:',
      CLEAR_BUTTON: 'Limpiar'
    },
    VISION_AND_MISSION: {
      VISION: 'Visión',
      MISSION: 'Misión'
    },
    SHOP_PRODUCT_CARD: {
      LOCAL_PRODUCT: 'Este producto es del país'
    },
    CHECKOUT_PAGE: {
      META_TITLE: 'Finalizar compra',
      BREAD_CRUMBS_HEADER: {
        HEADING: 'Finalizar compra',
        LINK_1: 'Tienda',
        LINK_2: 'Proceso de pago'
      },
      STEPS: {
        STEP_1: 'Carrito',
        STEP_2: 'Dirección',
        STEP_3: 'Método de pago',
      }
    },
    CHECKOUT_CART:{
      HEADER: "Carrito de compra <items>({{count}}) artículos</items>",
      CART_IS_EMPTY_TITLE: 'El carrito esta vacio',
      CART_IS_EMPTY_DESCRIPTION: 'Parece que no tienes artículos en tu carrito de compras.',
      CONTINUE_SHOPPING: 'Continuar comprando',
      BTN_PAY: 'Comprar ahora',
      BTN_RESET_CART: 'Salir'
    },
    CHECKOUT_PRODUCT_LIST: {
      PRODUCT: 'Producto',
      PACKAGING: 'Empaque',
      PRICE: 'Precio',
      QUANTITY: 'Cantidad',
      TOTAL_PRICE: 'Total'
    },
    CHECKOUT_SUMMARY: {
      SUB_TOTAL: 'Sub total',
      DISCOUNT: 'Descuento',
      SHIPPING: 'Gastos de envio',
      IVA_INCLUDED: '(Impuestos incluidos si aplican)',
      DISCLAIMER: '*Los gastos de envio pueden variar',
      BTN_APPLY_COUPON: 'Aplicar descuento'
    },
    CHECKOUT_BILLING_ADDRESS:{
      ADD_NEW_ADDDRESS: 'Agregar nueva dirección'
    },
    USER_ACCOUNT: {
      META_TITLE: 'Mi cuenta',
      BREAD_CRUMBS_HEADER: {
        HEADING: 'Mi cuenta',
        LINK_1: 'Información',
      },
      TABS: {
        TAB_1: 'Perfil',
        TAB_2: 'Dirección',
        TAB_3: 'Facturas',
        TAB_4: 'Contraseña'
      }
    }
  },
  GOOGLE_MAP:{
    GO_TO_BUSINESS: 'Ir al negocio'
  },
  GENERAL:{
    LOGIN: 'Iniciar Sesión',
    SEARCH: 'Buscar...',
    NOT_FOUND: 'No hay resultados',
    NO_RESULTS_FOUND_FOR: 'No se ha encontrado resultados para',
    TRY_CHECKING_TYPOS: 'Intenta revisar si hay errores de escritura.',
    PLEASE_ENTER_KEYWORDS: 'Por favor, escribe una palabra.',
    NAME: 'Nombre',
    EMAIL: 'Correo electrónico',
    PHONE: 'Teléfono',
    DIRECTION: 'Dirección',
    IDENTITY_NUM: 'Número de identidad',
    STATUS: 'Estado',
    ACTIVE: 'Activo',
    INACTIVE: 'Inactivo',
    FORM: {
      SELECT: 'Seleccionar',
      REQUIRED: {
        EMAIL: 'El correo electrónico es requerido'
      },
      INVALID: {
        EMAIL: 'El correo electrónico es invalido'
      }
    },
    LOCAL: 'Local',
    MORE: 'Más',
    PRIVACY_POLICY: 'Pólitica de privacidad',
    TERMS_OF_SERVICE: 'Terminos y condiciones',
    AGREE_TO: "Al registrarme, acepto <termsOfService>Terminos u condiciones</termsOfService> y <privacyPolicy>Pólitica de privacidad</privacyPolicy>.",
    BACK: 'Regresar',
    CONTINUE: 'Cotinuar',
    NEXT: 'Siguiente'
  },  
};

export default esPR;